export const FeedbackSignals = {
  Success: 'success',
  Error: 'error',
  Warning: 'warning',
  Info: 'info',
  Neutral: 'neutral',
  Helper: 'helper',
} as const;

export type TEFeedbackSignal = (typeof FeedbackSignals)[keyof typeof FeedbackSignals];
